import { create } from 'zustand';
import { api, ApiError } from '@/lib/api';
import type { SessionUser } from '@/lib/types';

interface AuthState {
  user: SessionUser | null;
  status: 'idle' | 'loading' | 'authed' | 'anon';
  bootstrap: () => Promise<void>;
  login: (email: string, password: string) => Promise<void>;
  logout: () => Promise<void>;
  setUser: (user: SessionUser) => void;
}

export const useAuth = create<AuthState>((set) => ({
  user: null,
  status: 'idle',

  bootstrap: async () => {
    set({ status: 'loading' });
    try {
      const user = await api.get<SessionUser>('/auth/me');
      set({ user, status: 'authed' });
    } catch (err) {
      if (err instanceof ApiError && err.status === 401) {
        set({ user: null, status: 'anon' });
        return;
      }
      throw err;
    }
  },

  login: async (email, password) => {
    const { user } = await api.post<{ user: SessionUser }>('/auth/login', {
      email,
      password,
    });
    set({ user, status: 'authed' });
  },

  logout: async () => {
    await api.post('/auth/logout');
    set({ user: null, status: 'anon' });
  },

  setUser: (user) => set({ user, status: 'authed' }),
}));
